import React, { FC, Fragment, useState } from 'react';
import { useIntl } from 'react-intl';
import { getDefaultDisplayDate } from 'src/app/common/utils';
import { PaginateListMore } from 'src/app/common/types';
import PruTable from 'src/app/common/components/PruTable/PruTable';
import { RulesLeadListItem } from 'src/app/modules/PulseLeads/types/auto-lead-reassignment-types';
import { CircularProgress } from '@mui/material';


type TypeProps = {
  isLoading: boolean;
  dataList?: PaginateListMore<RulesLeadListItem>;
  onRefresh: () => void;
  onChangePage: (page: number, rowsPerPage: number) => void;
  exportLeadList: () => Promise<void>;
};

const RulesLeadList: FC<TypeProps> = ({
  isLoading,
  dataList,
  onRefresh,
  onChangePage,
  exportLeadList
}) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const [loading, setLoadingData] = useState(false);
  const exportFile = () => {
    setLoadingData(true);
    exportLeadList().finally(() => { setLoadingData(false) });
  }

  return (
    <Fragment>
      <PruTable
        title={'Lead List'}
        disableBulkSelect
        operationDef={[]}
        headerBtnDef={[
          {
            color: 'primary',
            title: loading ? <CircularProgress style={{ color: 'gray' }} size={18} /> : Translation('export.list.text'),
            disabled: loading,
            onClick: exportFile,
            condition() {
              return !!(dataList?.items && dataList?.items?.length > 0);
            },
          },
        ]}
        columnDef={[
          {
            isId: true,
            hidden: true,
            keyIndex: '_id',
            displayName: '',
            renderData: (row) => '',
          },
          {
            keyIndex: 'leadIdOld',
            displayName: 'Old lead ID',
            renderData: (row) => row.leadIdOld || '-',
          },
          {
            keyIndex: 'leadIdNew',
            displayName: 'New lead ID	',
            renderData: (row) => row.leadIdNew || '-',
          },
          {
            keyIndex: 'alias',
            displayName: 'Lead name',
            renderData: (row) => row.alias || '-',
          },
          {
            keyIndex: 'agentCodeFrom',
            displayName: 'From Agent code',
            renderData: (row) => row.agentCodeFrom || '-',
          },
          {
            keyIndex: 'agentCodeTo',
            displayName: 'Assigned agent code',
            renderData: (row) => row.agentCodeTo || '-',
          },
          {
            keyIndex: 'leadDate',
            align: 'center',
            displayName: 'Processing date',
            renderData: (row) => getDefaultDisplayDate(new Date(row.leadDate), 'date'),
          },
          {
            keyIndex: 'status',
            align: 'center',
            displayName: 'Distribution status',
            renderData: (row) => row.status || '-',
          },
        ]}
        isLoading={isLoading}
        onRefresh={onRefresh}
        dataSource={dataList?.items}
        totalPages={dataList?.totalPages}
        totalRecords={dataList?.totalRecords}
        onChangePage={onChangePage}
      />
    </Fragment>
  );
};

export default RulesLeadList;
